import { Outlet, createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import type { CmsPageType } from '@beaded/models'
import { isValidPageType } from '@beaded/models'

const searchSchema = z.object({
  copyFrom: z.string().optional(),
})

export const Route = createFileRoute('/_auth/_global/page-admin/$pageType')({
  params: {
    parse: (raw): { pageType: CmsPageType } => {
      if (!isValidPageType(raw.pageType)) {
        throw new Error(`Unknown page type: ${raw.pageType}`)
      }
      return { pageType: raw.pageType }
    },
    stringify: (params) => ({ pageType: params.pageType }),
  },
  validateSearch: searchSchema,
  component: () => <Outlet />,
})
